import React, { Component } from 'react';
import $ from 'jquery';
import { connect } from "react-redux";
import Helping from "../../helpers/Helping";
import Notification from "../layout/Notification";
import "react-sweet-progress/lib/style.css";
import { setProfileError } from '../../actions/profile_action';
import { API_URL } from '../../config/urls';
import { MESSAGE, NODE_ENV } from "../../config/index";
import { setErrorFields, validateField } from "../../helpers/validationHelpers";
import LoadingButton from '../fields/LoadingButton';
import Service from '../../helpers/service';
import route from '../../config/routes';

class ManualTransaction extends Component {
    constructor(props) {
        super(props);

        this.state = {
            routeName: '',
            isLoading: false,
            error_type: '',
            error_message: '',
            username: '',
            token_ids: '',
            type: '',
            status: '',
            payment_type: '',
            campaign_type: 'NONE',
            transaction_hash: '',
            eth_transaction_hash: '',
            total_amount: '',
            eth_amount: '',
            checkout_id: '',
            blockchain: '',
            btnIsDisable: false
        }
    }

    componentDidMount() {
        let that = this;
        $(".close-slide").click(function () {
            that.resetForm();
            that.removeNetworkError();
            that.props.closeModal();
        });
        this.setErrorOnApiCall();
    }

    setErrorOnApiCall = () => {
        setProfileError(res => this.setState({ ...res }));
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    handleValueChange = async (e) => {
        const { name, value } = e.target;
        this.setState({
            [`${name}`]: value
        });

        if (name === "username") this.setState({ ...await validateField("string", name, value, "", 500, "Username") });
        if (name === "token_ids") this.setState({ ...await validateField("string", name, value, "", 100, "Token ID") });
        if (name === "total_amount") this.setState({ ...await validateField("decimal", name, value, "", 100, "Transaction Amount") });
        if (name === "eth_amount") this.setState({ ...await validateField("decimal", name, value, "", 100, "Eth Amount") });
        if (name === "checkout_id") this.setState({ ...await validateField("string", name, value, "", 100, "Checkout ID") });
        if (name === "blockchain") this.setState({ ...await validateField("string", name, value, "", 5, "Blockchain") });
    }

    checkEmptyInputFields = () => {
        let { state } = this,
            formHasError = false;

        if (state.username === '') {

            let errorObject = setErrorFields("username", Helping.getMessageString(MESSAGE.EMPTY, "Username"));
            this.setState(errorObject);
            formHasError = true;
        }

        if (state.token_ids.length === 0) {

            let errorObject = setErrorFields("token_ids", Helping.getMessageString(MESSAGE.EMPTY, "Token ID"));
            this.setState(errorObject);
            formHasError = true;
        }

        if (state.type === '') {

            let errorObject = setErrorFields("type", Helping.getMessageString(MESSAGE.SELECT, "Type"));
            this.setState(errorObject);
            formHasError = true;
        }

        if (state.payment_type === '') {
            let errorObject = setErrorFields("payment_type", Helping.getMessageString(MESSAGE.SELECT, "Payment Type"));
            this.setState(errorObject);
            formHasError = true;
        }

        if (state.blockchain === '') {

            let errorObject = setErrorFields("blockchain", Helping.getMessageString(MESSAGE.SELECT, "Blockchain"));
            this.setState(errorObject);
            formHasError = true;
        }

        if (Number(state.total_amount) < 0) {

            let errorObject = setErrorFields("total_amount", "Total Amount should be greater than or equal to 0");
            this.setState(errorObject);
            formHasError = true;
        }

        if (Number(state.eth_amount) < 0) {

            let errorObject = setErrorFields("eth_amount", "ETH Amount should be greater than or equal to 0");
            this.setState(errorObject);
            formHasError = true;
        }
        return formHasError;
    }

    resetForm = () => {
        this.setState({
            username: '',
            token_ids: '',
            type: '',
            payment_type: '',
            campaign_type: 'NONE',
            total_amount: '',
            eth_amount: '',
            transaction_hash: '',
            eth_transaction_hash: '',
            blockchain: '',
            checkout_id: '',
            isLoading: true,
            btnIsDisable: false,
            error_username_message: '',
            error_token_ids_message: '',
            error_type_message: '',
            error_payment_type_message: '',
            error_total_amount_message: '',
            error_eth_amount_message: '',
            error_transaction_hash_message: '',
            error_eth_hash_message: '',
            error_blockchain_message: '',
            error_checkout_id_message: '',
            error_campaign_type_message: ''
        })
    }

    scrollToTop = () => {
        $('.addButton-slide').animate({ scrollTop: 0 }, 'slow');
    }

    onSave = (e) => {
        e.preventDefault();

        let self = this,
            state = this.state,
            formHasError = this.checkEmptyInputFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let data = {
            action: 'manual-transfer',
            username: state.username,
            token_ids: Helping.convertCommaStringIntoArray(state.token_ids).map(str => parseInt(str)),
            type: state.type,
            status: 'processing',
            payment_type: state.payment_type,
            transaction_hash: state.transaction_hash,
            eth_transaction_hash: state.eth_transaction_hash,
            total_amount: state.total_amount ? parseFloat(state.total_amount) : 0,
            eth_amount: state.eth_amount ? parseFloat(state.eth_amount) : 0,
            checkout_id: state.checkout_id,
            which_bc: state.blockchain,
            campaign_type: state.campaign_type ? state.campaign_type : "NONE"
        }
        Service.postCall(API_URL.ADMIN_TRADING_API + route.GET_SETTING, data)
            .then(response => {
                self.setState(
                    {
                        error_message: response.data.message,
                        error_type: "success",
                        btnIsDisable: false
                    }, () => { this.scrollToTop(); this.resetForm() }
                );

            })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    return self.setState({
                        error_message: error.response.data.message.message,
                        error_type: "danger",
                        btnIsDisable: false
                    }, () => this.scrollToTop());
                }
                return this.setState({
                    isLoading: false,
                    ...Helping.setNetworkRequestError(error, "manual transaction")
                }, () => this.scrollToTop())
            });
    }

    render() {
        return (
            <div class="addButton-slide right-slider add-transaction" id="manual_transaction">
                <div class="slide-top">
                    <div class="slide-header">
                        <h4 class="title">Add Manual Transaction</h4>
                        <span class="caption">Add manual transaction and give detail about them.</span>
                    </div>
                    {/* <span class="close-slide">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                    </span> */}
                </div>

                {this.state.error_message &&
                    <Notification
                        type={this.state.error_type}
                        message={this.state.error_message}
                        callback={this.removeNetworkError}
                    />
                }

                <form class="info">
                    <div class="form-group">
                        <label for="username">Username</label>
                        <input type="text" name="username" class={`form-control ${this.state.error_username_message ? 'error-input' : ''}`} id="username" value={this.state.username} onChange={(e) => this.handleValueChange(e)} />
                        <span className="error-msg">{this.state.error_username_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="token_ids">Token ID</label>
                        <input type="text" name="token_ids" class={`form-control ${this.state.error_token_ids_message ? 'error-input' : ''}`} id="token_ids" value={this.state.token_ids} onChange={(e) => this.handleValueChange(e)} />
                        <span className="error-msg">{this.state.error_token_ids_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="type">Type</label> <br />
                        <select class={`form-select ${this.state.error_type_message ? 'error-input' : ''}`} name="type" aria-label="" id="type" value={this.state.type} onChange={(e) => this.handleValueChange(e)} >
                            <option value="">Select Type...</option>
                            <option value="sale">Sale</option>
                            <option value="gift">Gift</option>
                        </select>
                        <span className="error-msg">{this.state.error_type_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="paymentType">Payment Type</label> <br />
                        <select class={`form-select ${this.state.error_payment_type_message ? 'error-input' : ''}`} name="payment_type" aria-label="" id="paymentType" value={this.state.payment_type} onChange={(e) => this.handleValueChange(e)} >
                            <option value="">Select Payment Type...</option>
                            <option value="DEFAULT">DEFAULT</option>
                            <option value="CARD">CARD</option>
                            <option value="EXISTING_CARD">EXISTING CARD</option>
                            <option value="WALLET">WALLET</option>
                            <option value="ETH">ETH</option>
                        </select>
                        <span className="error-msg">{this.state.error_payment_type_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="campaignType">Campaign Type</label> <br />
                        <select class={`form-select ${this.state.error_campaign_type_message ? 'error-input' : ''}`} name="campaign_type" aria-label="" id="campaignType" value={this.state.campaign_type} onChange={(e) => this.handleValueChange(e)} >
                            <option value="NONE">NONE</option>
                            <option value="ISL">ISL</option>
                            <option value="CARDANO">CARDANO</option>
                            <option value="MORROW">MORROW</option>
                            <option value="PRESTIGE">PRESTIGE</option>
                        </select>
                        <span className="error-msg">{this.state.error_campaign_type_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="amount">Total Amount($)</label>
                        <input type="number" name="total_amount" class={`form-control ${this.state.error_total_amount_message ? 'error-input' : ''}`} id="amount" value={this.state.total_amount} onChange={(e) => this.handleValueChange(e)} />
                        <span className="error-msg">{this.state.error_total_amount_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="ethAmount">ETH Amount</label>
                        <input type="number" name="eth_amount" class={`form-control ${this.state.error_eth_amount_message ? 'error-input' : ''}`} id="ethAmount" value={this.state.eth_amount} onChange={(e) => this.handleValueChange(e)} />
                        <span className="error-msg">{this.state.error_eth_amount_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="transactionHash">Transaction Hash</label>
                        <input type="text" name="transaction_hash" class={`form-control ${this.state.error_transaction_hash_message ? 'error-input' : ''}`} id="transactionHash" value={this.state.transaction_hash} onChange={(e) => this.handleValueChange(e)} />
                        <span className="error-msg">{this.state.error_transaction_hash_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="ethHash">Ethereum Transaction Hash</label>
                        <input type="text" name="eth_hash" class={`form-control ${this.state.error_eth_hash_message ? 'error-input' : ''}`} id="ethHash" value={this.state.eth_transaction_hash} onChange={(e) => this.handleValueChange(e)} />
                        <span className="error-msg">{this.state.error_eth_hash_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="blockchain">Blockchain</label> <br />
                        <select class={`form-select ${this.state.error_blockchain_message ? 'error-input' : ''}`} name="blockchain" aria-label="" id="blockchain" value={this.state.blockchain} onChange={(e) => this.handleValueChange(e)} >
                            <option value="">Select Blockchain...</option>
                            <option value="CARDANO">CARDANO</option>
                            <option value="MATIC">MATIC</option>
                            {NODE_ENV === 'DEV' &&
                                <option value="TEZOS">TEZOS</option>
                            }
                            <option value="ETH">ETH</option>
                        </select>
                        <span className="error-msg">{this.state.error_blockchain_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="checkoutId">Checkout ID</label>
                        <input type="text" name="checkout_id" class={`form-control ${this.state.error_checkout_id_message ? 'error-input' : ''}`} id="checkoutId" value={this.state.checkout_id} onChange={(e) => this.handleValueChange(e)} />
                        <span className="error-msg">{this.state.error_checkout_id_message}</span>
                    </div>
                    <div class="slide-btn">
                        <div className="float-left">
                            <button class="close-slide custom-btn semi-dark-btn sm-btn" onClick={e => e.preventDefault()}>Close</button>
                        </div>

                        <div class="float-right">
                            {!this.props.id &&
                                <button class="custom-btn semi-dark-btn sm-btn" onClick={(e) => { e.preventDefault(); this.resetForm() }}>Reset</button>
                            }
                            {this.state.btnIsDisable ?
                                <LoadingButton class_name={"sm-btn"} />
                                :
                                <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onSave(e)}>{this.state.btnIsDisable ? "Loading..." : "Save"}</button>
                            }
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        profile: state.profile,
        transactions: state.transactions,
        buyers: state.buyers,
        isLoading: state.transactionsMeta.isLoading,
        page: state.transactionsMeta.page,
        count: state.transactionsMeta.length,
        total: state.transactionsMeta.total
    }
}


export default connect(mapStateToProps, null)(ManualTransaction)